/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTaskRequest
 */
export interface UpdateTaskRequest {
    /**
     * 
     * @type {Date}
     * @memberof UpdateTaskRequest
     */
    onHoldUntilDate: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskRequest
     */
    holdDescription: string | null;
}

/**
 * Check if a given object implements the UpdateTaskRequest interface.
 */
export function instanceOfUpdateTaskRequest(value: object): value is UpdateTaskRequest {
    if (!('onHoldUntilDate' in value) || value['onHoldUntilDate'] === undefined) return false;
    if (!('holdDescription' in value) || value['holdDescription'] === undefined) return false;
    return true;
}

export function UpdateTaskRequestFromJSON(json: any): UpdateTaskRequest {
    return UpdateTaskRequestFromJSONTyped(json, false);
}

export function UpdateTaskRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTaskRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'onHoldUntilDate': (new Date(json['onHoldUntilDate'])),
        'holdDescription': json['holdDescription'],
    };
}

export function UpdateTaskRequestToJSON(value?: UpdateTaskRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'onHoldUntilDate': ((value['onHoldUntilDate']).toISOString().substring(0,10)),
        'holdDescription': value['holdDescription'],
    };
}

